import StateEntity from "../state";
import BaseExtension from "./base";
import BaseController from '../players/base';
import { createElement } from "../utils";

import type { Player$ExtensionOptions } from '../types/Options';

const CN = 'rmp-ext-crawl';
const CN_TEXT = `${CN}__text`;

export default class CrawlExtension extends BaseExtension {
   $crawl;
   $intervalId;

   constructor(
      player: BaseController,
      state: StateEntity,
      options: Player$ExtensionOptions,
   ) {
      super(player, state, options, []);
      this.logger.debug('crawl:extensions:creating');
      this.render();
      this.logger.debug('crawl:extensions:created');

      options.bus.on('fullscreenchanging', () => {
         setTimeout(() => this.refresh(this.options.crawl, this.options.showCrawl), 100);
      });

      options.bus.on('resizeplayer', () => {
         setTimeout(() => this.refresh(this.options.crawl, this.options.showCrawl), 100);
      });
   }

   startAnimation(interval: number = 100) {
      if (this.$intervalId) {
         return;
      }

      const crawlTextElement = document.getElementById('crawlText');
      const containerWidth = document.querySelector('.rmp-ext-crawl').offsetWidth;
      const textWidth = crawlTextElement.offsetWidth;

      let currentPosition = containerWidth;

      const crawl = () => {
         currentPosition--;

         if (currentPosition < -textWidth) {
            currentPosition = containerWidth;
         }

         crawlTextElement.style.transform = `translateX(${currentPosition}px)`;
      };

      this.$intervalId = setInterval(crawl, interval);
   }

   render() {
      this.$crawl = createElement('div', { class: CN, 'data-testid': 'crawl' });
      const content = createElement('div', {
         id: 'crawlText', class: CN_TEXT, title: this.options.crawl, tabindex: 0
      }, this.$crawl);

      content.innerHTML = clearHtml(this.options.crawl.text) || '';

      this.$crawl.style.color = this.options.crawl.textColor;
      this.$crawl.style.backgroundColor = this.options.crawl.backgroundColor;

      this.toggle(this.options.showCrawl);

      setTimeout(() => this.startAnimation(this.options.crawl.speed));
   }

   getOuter() {
      return this.$crawl;
   }

   toggle(visibility: boolean) {
      if (visibility) {
         this.$crawl.style.display = 'block';
      } else {
         this.$crawl.style.display = 'none';
      }
   }

   refresh(crawl, visibility) {
      if (!this.$crawl) return;

      const crawlText = document.getElementById('crawlText');
      crawlText.innerHTML = clearHtml(crawl.text) || '';
      this.$crawl.style.color = crawl.textColor;
      this.$crawl.style.backgroundColor = crawl.backgroundColor;
      clearInterval(this.$intervalId);
      this.$intervalId = null;
      this.toggle(visibility);

      if (visibility) {
         this.startAnimation(crawl.speed);
      }
   }

   destroy() {
      super.destroy();
      if (this.$crawl) {
         const parent = this.$crawl.parentNode;
         parent.removeChild(this.$crawl);
         this.$crawl = null;
         clearInterval(this.$intervalId);
         this.$intervalId = null;
      }
   }
}

function clearHtml(html) {
   let clearedHtml = html.replace(/(\r\n|\n|\r)/gm, '');
   // remove br tags
   return clearedHtml.replace(/<br\s*[\/]?>/gi, '');
}
